import React from "react";

export const Padlock: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 40 40"
    >
      <g fillRule="nonzero">
        <path d="M20.882 27.923a.414.414 0 00-.417-.423H4.167a.834.834 0 01-.834-.833v-22.5c0-.46.373-.834.834-.834h7.621c.316 0 .604.178.745.46l1.35 2.707a3.332 3.332 0 002.98 1.833h14.804c.46 0 .833.373.833.834v6.813a.406.406 0 00.352.4c.823.125 1.62.385 2.36.768a.41.41 0 00.412.003.417.417 0 00.21-.356V8.333A3.335 3.335 0 0032.5 5H17.378a.834.834 0 01-.745-.46l-1.35-2.698A3.33 3.33 0 0012.303 0h-8.97A3.333 3.333 0 000 3.333V27.5a3.333 3.333 0 003.333 3.333H20.42a.41.41 0 00.417-.405c.006-.633.023-1.851.045-2.505z" />
        <path d="M37.92 25.882a.5.5 0 01-.42-.5v-1.634a5.834 5.834 0 00-11.667 0v1.605c0 .26-.185.484-.441.53a2.5 2.5 0 00-2.059 2.45V37.5a2.5 2.5 0 002.5 2.5H37.5a2.5 2.5 0 002.5-2.5v-9.167a2.5 2.5 0 00-2.08-2.451zm-6.253 9.535a1.668 1.668 0 010-3.334 1.667 1.667 0 010 3.334zm2.5-10c0 .23-.187.416-.417.416h-4.167a.416.416 0 01-.416-.416V23.75a2.5 2.5 0 015 0v1.667z" />
      </g>
    </svg>
  );
};
